import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ConstOperatorParameters} from "#template/nodes/geometry-graph/attribute/const-operator/geometry-const-operator-node"
import {GeometryConstOperatorNode, constOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/const-operator/geometry-const-operator-node"

export type MeshGeometryConstOperatorParameters = ConstOperatorParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryConstOperatorParameters> = {
    nodeClass: "MeshGeometryConstOperator",
    validation: {
        parameters: constOperatorParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryConstOperator extends GeometryConstOperatorNode<2, MeshGeometryAttributeLikeNode> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
